import React, { useState, useRef, useEffect } from 'react';
import './index.module.less';

import NavBar from '@components/NavBar';

import { Api } from '@apis/client';
import Http from '@helpers/Http';
import Filter from '@helpers/Filter';
import { settingList, areaTipItems } from './contants';
import { SettingItem, TipItem } from './index.d';
import Switch from "react-switch";
import BrowserHistory from '@helpers/BrowserHistory';

import userStore from '@stores/user';
import FridayService from '@services/friday';

interface ItemProps {
  item: SettingItem;
  onEnable: (value: boolean) => void;
  switchStatus: boolean;
}

interface AreaTipItemProps {
  item: TipItem;
}

const Item = (props: ItemProps) => {
  const { item, switchStatus, onEnable } = props;

  const onChangeSwitch = (checked: boolean) => {
    FridayService.addEvent('security_guard_intelligent_security_guard_switch', {type: checked?'开':'关'});
    onEnable(checked);
  }


  return (
    <div className="flex" styleName="item">
      <div className="flex" styleName='item-title-row'>
        <span styleName="item-title">{ item.title }</span>
        <Switch
          styleName='border-switch'
          uncheckedIcon={ false }
          checkedIcon={ false }
          offColor={ '#ffffff' }
          onColor={ '#256eff' }
          boxShadow={ '0 0 1px 1px rgba(0, 0, 0, 0.2)' }
          activeBoxShadow={ '0 0 1px 1px rgba(0, 0, 0, 0.08)' }
          width={ 51 }
          height={ 28 }
          onChange={(checked) => onChangeSwitch(checked)} checked={switchStatus} />
      </div>
      <span styleName="item-desc">{ item.desc }</span>
    </div>
  )
}

const AreaTipItem = (props: AreaTipItemProps) => {
  const { item } = props;

  let applyBorderRadius = {};
  if (item.isFirst) {
    applyBorderRadius = {
      borderTopLeftRadius: '.16rem',
      borderTopRightRadius: '.16rem',
    }
  } else if (item.isLast) {
    applyBorderRadius = {
      borderBottomLeftRadius: '.16rem',
      borderBottomRightRadius: '.16rem',
    }
  }

  return (
    <div className="flex" styleName='tip-item-container' style={applyBorderRadius}>
      <div className="flex" styleName="tip-item">
        <img styleName='tip-item-icon' src={item.icon} alt=''/>
        <div className="flex" styleName="tip-item-content">
          <span styleName='item-title'>{ item.title }</span>
          <span styleName="tip-item-desc">{ item.desc }</span>
        </div> 
        </div> 
        {!item.isLast ? <span styleName="tip-item-sep" /> : <span styleName="tip-item-padding-bottom" />}
    </div> 
  )
}

const SmartGuardSetting = () => {
  const params = useRef(Filter.urlParams(window.location.search));
  const [status, setSwitchStatus] = useState(false);

  const editSwitchStatus = async (enable: boolean) => {
    Http.post(Api.PutGuardSwitchStatus,
      { snCode: params.current.sncode, company: params.current.company, type: 2, enabled: enable}
    ).then(() => {
        setSwitchStatus(enable);
    })
  }

  const getSwitchInfo = async() => {
    const result = await Http.post(Api.GetGuardSettingSwitchInfo,
      { snCode: params.current.sncode, company: params.current.company, type: 2 }
    );
    if(result && result?.data) {
      setSwitchStatus(result.data === true);
    }
  }

  const renderSettingItem = () => {
    const items = settingList.map((item: any, index: number) => {
      return (
        <Item key={ index } item={ item } onEnable={ editSwitchStatus } switchStatus={status} />
      )
    });

    return items;
  }

  const renderAreaTipItem = () => {
    const items = areaTipItems.map((item: any, index: number) => {
      return (
        <AreaTipItem key={ index } item={ item }/>
      )
    });

    return items;
  }


  useEffect(() => {
    FridayService.addEvent('security_guard_intelligent_security_guard_page_itself_display');
    getSwitchInfo();
  }, [])

  const goToFeedback = async () => {
    BrowserHistory.push(`${PUBLIC_URL}/locationfeedback?phone=${userStore.userInfo.phone}&sncode=${params.current.sncode}&company=${params.current.company}`);
  }

  return (
    <div styleName="container">
      <NavBar
        title="智能安全守护"
      />
      <div styleName="list">
        { renderSettingItem() }
      </div>
      <div styleName="list">
        { renderAreaTipItem() }
      </div>
      <div styleName="bottomProtocol">
        <span>{'定位识别不准？'}</span>
        <span styleName='link-text' onClick={ goToFeedback }>{ '我要反馈' }</span>
      </div>
    </div>
  )
}

export default SmartGuardSetting;
